<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Deals</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.products.deals.index')">
                                    Deals
                                </Link>
                            </li>
                            <li class="breadcrumb-item active"> {{ isEditing ? "Edit" : "Add" }} Deal
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="saveDeal" enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Deal Name</label>
                                        <input type="text" v-model="deal.name" class="form-control"
                                               placeholder="Deal Name"
                                               required>
                                        <div v-if="deal.errors.name" class="text-danger text-small">
                                            {{ deal.errors.name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-if="!deal.is_combo">
                                    <div class="controls">
                                        <label class="form-label">Main Product Quantity</label>
                                        <input type="number" v-model="deal.deal_quantity" class="form-control"
                                               placeholder="Deal Quantity"
                                               required>
                                        <div v-if="deal.errors.deal_quantity" class="text-danger text-small">
                                            {{ deal.errors.deal_quantity }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-if="!deal.is_combo">
                                    <div class="controls">
                                        <label class="form-label">Number of Free Products</label>
                                        <input type="number" v-model="deal.number_of_free_products" class="form-control"
                                               placeholder="Number of Free Products"
                                               required>
                                        <div v-if="deal.errors.number_of_free_products" class="text-danger text-small">
                                            {{ deal.errors.number_of_free_products }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Deal Image</label>
                                        <template v-if="this.deal.image.hasOwnProperty('image')">
                                            <div class="row">
                                                <div class="col-3">
                                                    <a :href="deal.image.image" target="_blank">
                                                        <img :src="deal.image.image_thumbnail"
                                                             :alt="deal.name +' Image'"
                                                             class="img-thumbnail img-fluid"
                                                             style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                                                    </a>
                                                </div>
                                            </div>
                                        </template>
                                        <button type="button" data-toggle="modal" data-target="#gallery-modal"
                                                class="form-control"> {{ deal.image ? 'Change' : 'Choose' }}
                                            Deal Image
                                        </button>
                                        <div v-if="deal.errors.image" class="text-danger text-small">
                                            {{ deal.errors.image }}
                                        </div>
                                    </div>
                                </div>

                                <template v-if="deal.is_combo">
                                    <div class="form-group">
                                        <div class="controls">
                                            <label class="form-label">Deal Combo Price</label>
                                            <input type="number" v-model="deal.price" class="form-control"
                                                   placeholder="Deal Combo Price" :required="deal.is_combo">
                                            <div v-if="deal.errors.price" class="text-danger text-small">
                                                {{ deal.errors.price }}
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <div class="form-group">
                                    <label class="form-label">Operating Day</label>
                                    <select class="form-control" v-model="deal.operating_day">
                                        <option :value="null" selected>EVERYDAY</option>
                                        <option v-for="[value, name] in Object.entries(daysOfWeek)" :value="value">{{ name }}</option>
                                    </select>
                                    <div v-if="deal.errors.operating_day" class="text-danger text-small">
                                        {{ deal.errors.operating_day }}
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <textarea
                                            v-model="deal.description"
                                            placeholder="Enter something..."
                                            rows="1"
                                            class="form-control"
                                            required
                                        ></textarea>
                                        <div v-if="deal.errors.description" class="text-danger text-small">
                                            {{ deal.errors.description }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" v-if="!deal.is_combo">
                                    <div class="controls">
                                        <label class="form-label">Main Products</label>
                                        <v-select multiple v-model="deal.main_products" :options="products"
                                                  label="name"
                                                  :reduce="name => name.id"></v-select>

                                        <span v-if="deal.errors.main_products"
                                              class="text-danger text-small">{{
                                                deal.errors.main_products
                                            }}
                                        </span>

                                        <template v-if="deal.errors">
                                            <template v-for="(value, key) in deal.main_products">
                                                <span class="text-danger text-small">
                                                    {{ deal.errors[`main_products.${key}`] }}
                                                </span><br>
                                            </template>
                                        </template>

                                    </div>
                                </div>

                                <div class="form-group" v-if="!deal.is_combo">
                                    <div class="controls">
                                        <label class="form-label">Main Products Size</label>
                                        <v-select v-model="deal.main_product_size" :options="sizes"
                                                  label="name"
                                                  :reduce="name => name.id"></v-select>

                                        <span v-if="deal.errors.main_product_size"
                                              class="text-danger text-small">{{
                                                deal.errors.free_product_size
                                            }}</span>
                                    </div>
                                </div>

                                <div class="form-group" v-if="!deal.is_combo">
                                    <div class="controls">
                                        <label class="form-label">Free Products</label>
                                        <v-select multiple v-model="deal.available_free_products" :options="products"
                                                  label="name"
                                                  :reduce="name => name.id"></v-select>

                                        <span v-if="deal.errors.available_free_products"
                                              class="text-danger text-small">{{
                                                deal.errors.available_free_products
                                            }}</span>

                                        <template v-if="deal.errors">
                                            <template v-for="(value, key) in deal.available_free_products">
                                                <span class="text-danger text-small">
                                                    {{ deal.errors[`available_free_products.${key}`] }}
                                                </span><br>
                                            </template>
                                        </template>
                                    </div>
                                </div>

                                <div class="form-group" v-if="!deal.is_combo">
                                    <div class="controls">
                                        <label class="form-label">Free Products Size</label>
                                        <v-select v-model="deal.free_product_size" :options="sizes"
                                                  label="name"
                                                  :reduce="name => name.id"></v-select>

                                        <span v-if="deal.errors.free_product_size"
                                              class="text-danger text-small">{{
                                                deal.errors.free_product_size
                                            }}</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" id="defaultCheck2"
                                                   v-model="deal.is_active" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck2">
                                                Is this Deal Available?
                                            </label>
                                        </div>
                                        <span v-if="deal.errors.is_active"
                                              class="text-danger text-small">{{ deal.errors.is_active }}</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <div class="form-check">
                                            <input class="form-check-input" @change="handleComboChange" type="checkbox" id="defaultCheck3"
                                                   v-model="deal.is_combo" :true-value="true" :false-value="false">
                                            <label class="form-check-label" for="defaultCheck3">
                                                Is this a Combo Deal?
                                            </label>
                                        </div>
                                        <span v-if="deal.errors.is_combo"
                                              class="text-danger text-small">{{ deal.errors.is_combo }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <template v-if="deal.is_combo">
                                    <template v-for="(n,index) in formCount">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <div class="controls">
                                                        <label class="form-label">Product</label>
                                                        <v-select
                                                            v-model="deal.combo_products[index].product_id"
                                                            :options="products"
                                                            label="name"
                                                            :reduce="name => name.id"></v-select>

                                                        <span v-if="deal.errors.combo_products"
                                                              class="text-danger text-small">{{
                                                                deal.errors.combo_products
                                                            }}
                                                    </span>

                                                        <template v-if="deal.errors">
                                                            <template v-for="(value, key) in deal.combo_products">
                                                <span class="text-danger text-small">
                                                    {{ deal.errors[`combo_products.${key}.product_id`] }}
                                                </span><br>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <div class="controls">
                                                        <label class="form-label">Product Size</label>
                                                        <v-select v-model="deal.combo_products[index].size_id"
                                                                  :options="sizes"
                                                                  label="name"
                                                                  :reduce="name => name.id">
                                                        </v-select>

                                                        <template v-if="deal.errors">
                                                            <template v-for="(value, key) in deal.combo_products">
                                                <span class="text-danger text-small">
                                                    {{ deal.errors[`combo_products.${key}.size_id`] }}
                                                </span><br>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4">
                                                <div class="form-group"><label>Quantity</label> <br>
                                                    <div class="input-group">
                                                        <input type="number"
                                                               v-model="deal.combo_products[index].quantity"
                                                               placeholder="Quantity" required
                                                               class="form-control">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <div class="col-md-12">
                                        <span><a href="#delivery-prices" @click="addToFormCount">Add +</a></span>

                                        <span v-if="formCount > 1"><a href="#delivery-prices"
                                                                      @click="subtractFromFormCount"
                                                                      class="text-danger">- Remove</a>
                                            </span>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                            <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                    :disabled="saving">
                                {{ isEditing ? 'Update' : 'Save' }}
                                <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </div>
        <gallery-modal @chooseImage="chosenImage" gallery-header="Add Image to Deal Gallery"></gallery-modal>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from "@inertiajs/vue2";
import GalleryModal from "@/Shared/GalleryModal";

export default {
    metaInfo: {title: 'Create Deals'},
    name: 'DealCreate',
    props: [
        'products',
        'isEditing',
        'dealData',
        'sizes',
        'daysOfWeek',
    ],
    components: {
        Link,
        GalleryModal,
    },
    layout: Layout,
    data() {
        return {
            deal: this.$inertia.form({
                name: null,
                image: {},
                description: null,
                is_active: false,
                available_free_products: [],
                main_products: [],
                deal_quantity: null,
                number_of_free_products: null,
                is_combo: false,
                price: null,
                main_product_size: null,
                free_product_size: null,
                combo_products: [],
                operating_day: null,
            }),
            saving: false,
            formCount: 0,
        }
    },
    methods: {
        handleComboChange(){
            console.log("triggered");
            console.log(this.deal.is_combo);
           if(this.deal.is_combo && this.formCount<1){
               this.addToFormCount();
           }

           if(!this.deal.is_combo){
               this.formCount = 0;
               this.deal.combo_products =[];
           }
        },

        chosenImage(image) {
            if (this.deal.hasOwnProperty('image')) {
                this.deal.image = image;
            }
        },
        async saveDeal() {
            this.saving = true;

            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.deal.image = this.deal.image.image

            if (this.isEditing) {
                this.deal.put(route('admin.products.deals.update', this.dealData.id), options);
            } else {
                this.deal.post(route('admin.products.deals.store'), options);
            }
        },
        addToFormCount() {
            this.formCount += 1;
            this.deal.combo_products.push({
                product_id: null,
                size_id: null,
                quantity: 1,
            });
        },
        subtractFromFormCount() {
            if (this.formCount > 1) {
                this.formCount -= 1;
                this.deal.combo_products.pop();
            } else {
                this.formCount = 1;
            }
        },
    },
    mounted() {
        if (this.isEditing) {
            this.deal.name = this.dealData.name;
            this.deal.description = this.dealData.description;
            this.deal.is_active = this.dealData.status;
            this.deal.number_of_free_products = this.dealData.free_product_quantity;
            this.deal.deal_quantity = this.dealData.product_quantity;
            this.deal.image = {
                image: this.dealData.image,
                image_thumbnail: this.dealData.image
            };
            this.deal.is_combo = this.dealData.is_combo;
            this.deal.price = this.dealData.price;
            this.deal.operating_day = this.dealData.operating_day;

            if (!this.dealData.is_combo) {
                this.deal.main_products = this.dealData.main_products;

                this.deal.available_free_products = this.dealData.free_products.map((product) => {
                    return product.id
                });

                this.deal.main_products = this.dealData.products.map((product) => {
                    return product.id
                });

                this.deal.main_product_size = this.dealData.main_product_size;
                this.deal.free_product_size = this.dealData.free_product_size;
            } else {
                this.deal.main_products = this.dealData.products.map((item) => {
                    this.deal.combo_products.push({
                        product_id: item.id,
                        size_id: item.pivot.size_id,
                        quantity: item.pivot.quantity
                    })
                });
                this.formCount = this.dealData.products.length === 0 ? 1 : this.dealData.products.length;
            }

        } else {
            this.deal.combo_products = []
        }
    },
}
</script>
